<template>
  <div class="button-google-login">
    <button
      type="button"
      class="btn"
      :style="buttonStyle"
    >
      <div class="d-flex flex-row align-item-center">
        <IconGoogleLoginLogo class="col-12" />
      </div>
    </button>
  </div>
</template>

<script>
import IconGoogleLoginLogo from "@/components/atoms/icons/IconGoogleLoginLogo.vue"

export default {
  name: "ButtonGoogleLogin",
  components: {
    IconGoogleLoginLogo,
  },
  props: {
    width: {
      type: String,
      default: function () {
        return ''
      },
    },
  },

  computed: {
    buttonStyle: function () {
      return {
        width: `${this.width}`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  background-color: transparent;
  border: none;
  padding: none;
  outline: none;
}
.button-google-login > button {
  padding: 0;
}
</style>